import { graphql } from "../gql";
import { useQuery } from "@apollo/client";

const GetUserLessonsInfoQuery = graphql(`
  query getUserLessonsInfo($userId: String!) {
    getUserLessonsInfo(userId: $userId) {
      lessonsInfo {
        groupId
        groupName
        isOneOnOne
        lessonCount
        noShowCount
        totalFeedbackReceived
      }
    }
  }
`);

export function useGetUserLessonsInfo(userId: string) {
  const { data, loading, error } = useQuery(GetUserLessonsInfoQuery, {
    variables: { userId },
    skip: !userId,
  });

  return {
    lessonsInfo: data?.getUserLessonsInfo?.lessonsInfo ?? [],
    loading,
    error,
  };
}

export type LessonInfo = NonNullable<
  ReturnType<typeof useGetUserLessonsInfo>["lessonsInfo"][number]
>;
